import { render, staticRenderFns } from "./ClockView.vue?vue&type=template&id=55bce9f6&scoped=true&"
import script from "./ClockView.vue?vue&type=script&lang=js&"
export * from "./ClockView.vue?vue&type=script&lang=js&"
import style0 from "./ClockView.vue?vue&type=style&index=0&id=55bce9f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bce9f6",
  null
  
)

export default component.exports